import { useContext } from 'react';
import { AppConfigContext } from '@/features/app-providers/app-config-provider';
import { PageTitle, replaceParams } from './getStaticPageUrl';

export const useGetPageUrl = () => {
    const routes = useContext(AppConfigContext).routes;
    return (page: PageTitle, params?: Record<string, string>) => {
        const route = routes[page];
        if (params && route) {
            return replaceParams(route, params);
        }
        return route ?? '#';
    };
};
